<!--
	ValuePicker.svelte
-->

<script>

    import { onMount } from 'svelte';
    import { fly, fade } from 'svelte/transition'

    // SMUI components
    import IconButton, { Icon } from '@smui/icon-button';
    import { mdiPlay } from '@mdi/js';
    import { Svg } from '@smui/common/elements';

    export let values;
    export let value;       // bound to searchFilters.distance

    let currIndex = -1;
    let isChangingDown = false;
    let isChangingUp = false;
    let oldDisplayValue = "";
    $: displayValue = currIndex > -1 ? values[currIndex].label : "";

    // must initialize to the bound prop value!
    onMount(() => {
        initCurrIndex();
    })

    const initCurrIndex = () => {
        for (let i in values) {
            if (values[i].value == value) currIndex = i;
        }
    }

    const onClickDown = () => {
        if (currIndex == 0) return;
        isChangingDown = true;
        oldDisplayValue = displayValue;
        currIndex--;
        value = values[currIndex].value;
        setTimeout(() => {
            isChangingDown = false;
        }, 500);
    }
    
    const onClickUp = () => {
        if (currIndex == values.length-1) return;
        isChangingUp = true;
        oldDisplayValue = displayValue;
        currIndex++;
        value = values[currIndex].value;
        setTimeout(() => {
            isChangingUp = false;
        }, 500);
    }
    
</script>

<style>
    .value-picker {
        display: flex;
        align-items: center;
        /* border: 1px solid red; */
    }

    .value-display-wrapper {
        position: relative;
        width: 50px;
        overflow: hidden;
        /* border: 1px solid red; */
    }

    .value-display {
        width: 100%;
        text-align: center;
        font-size: 1em;
        color: var(--tcare-primary);
    }

    .left-nudge {
        margin-left: -20px;
    }

    :global(.value-button) {
        width: 50px !important;
        height: 50px !important;
        border-radius: 50%;
        /* border: 1px solid green; */
    }
    
    :global(.mdc-icon-button__icon) {
        width: 50px !important;
        height: 50px !important;
        fill: var(--tcare-primary);
    }

</style>

<div class="value-picker">
    <!-- left button -->
    <div class="value-button rotate-180">
        <IconButton class="value-button" on:click={onClickDown}>
            <Icon component={Svg} viewBox="0 0 24 24"><path d={mdiPlay} /></Icon>        
        </IconButton>
    </div>

    <div class="value-display-wrapper flex-row left-nudge">
        {#if isChangingDown}
            <div class="value-display" in:fly="{{ x: 100, duration: 500 }}">
                {displayValue}
            </div>
        {:else if isChangingUp}
            <div class="value-display" in:fly="{{ x: -100, duration: 500 }}">
                {displayValue}
            </div>
        {:else}
            <div class="value-display">
                {displayValue}
            </div>
        {/if}

    </div>

    <!-- right button -->
    <div class="value-button left-nudge">
        <IconButton class="value-button" on:click={onClickUp}>
            <Icon component={Svg} viewBox="0 0 24 24">
                <path d={mdiPlay} />
            </Icon>        
        </IconButton>
    </div>

</div>
